


















import { Vue, Component, Prop } from 'vue-property-decorator'
@Component({
  components: {
  }
})
export default class CouponItem extends Vue {
  @Prop(Object) readonly card!: object

  showDetail = false;

  handleToggle() {
    this.showDetail = !this.showDetail
  }

  handleClick() {
    this.$emit('click', this.card)
  }
}
